module.exports = __webpack_public_path__ + "assets/img/22_273_big.1e05fcb2.jpg";